/** @format */

import { marketoProductFields } from './marketo-product-form-fields';
import { contactFormFields } from '@forms/form-types/contact-form/contact-form-fields';
import { simpleContactFormFields } from '@forms/form-types/simple-contact-form/simple-contact-form-fields';
import { visContactFormFields } from '@forms/form-types/vis-contact-form/vis-contact-form-fields';
import { interoperabilityFormFields } from '@forms/form-types/interoperability-form/interoperability-form-fields';
import { reimbursmentFormFields } from '@forms/form-types/reimbursement-form/reimbursement-form-fields';
import { supplierFormFields } from '@forms/form-types/supplier-form/supplier-form-fields';
import { sirFormFields } from '@forms/form-types/sir-form/sir-form-fields';
import { edgeHyperarcFormFields } from '@forms/form-types/edge-hyperarc-en-au-form/edge-hyperarc-en-au-form-fields';
import { contactNoAreaOfInquiryFormFields } from '@forms/form-types/contact-form-no-area-of-inquiry/contact-form-no-area-of-inquiry-form-fields';
import { careersFormFields } from '@forms/form-types/careers-form/careers-form-fields';
import { FieldProperties } from '@forms/form-components/form-modals';

interface FormFieldProps {
  path: string;
  key: string;
  fieldCollection: FieldProperties;
}

/**
 * Get Form Field URL and Key.
 */
export const getFormFields = (type: string): FormFieldProps => {
  let formFieldInfo = {
    path: `contact-form/contact-form-fields`,
    key: `contactFormFields`,
    fieldCollection: contactFormFields,
  };

  switch (type) {
    case 'interoperability':
      formFieldInfo = {
        path: `interoperability-form/interoperability-form-fields`,
        key: `interoperabilityFormFields`,
        fieldCollection: interoperabilityFormFields,
      };
      break;
    case 'reimbursement':
      formFieldInfo = {
        path: `reimbursement-form/reimbursement-form-fields`,
        key: `reimbursementFormFields`,
        fieldCollection: reimbursmentFormFields,
      };
      break;
    case 'supplier':
      formFieldInfo = {
        path: `supplier-form/supplier-form-fields`,
        key: `supplierFormFields`,
        fieldCollection: supplierFormFields,
      };
      break;
    case 'careers-form':
      formFieldInfo = {
        path: `careers-form/careers-form-fields`,
        key: `careersFormFields`,
        fieldCollection: careersFormFields,
      };
      break;
    case 'marketo-product':
      formFieldInfo = {
        path: `varian-form-paragraph/marketo-product-form-fields`,
        key: `marketoProductFields`,
        fieldCollection: marketoProductFields,
      };
      break;
    case 'simple-contact':
      formFieldInfo = {
        path: `simple-contact-form/simple-contact-form-fields`,
        key: `simpleContactFormFields`,
        fieldCollection: simpleContactFormFields,
      };
      break;
    case 'vis-contact':
      formFieldInfo = {
        path: `vis-contact-form/vis-contact-form-fields`,
        key: `visContactFormFields`,
        fieldCollection: visContactFormFields,
      };
      break;
    case 'sir':
      formFieldInfo = {
        path: `sir-form/sir-form-fields`,
        key: `sirFormFields`,
        fieldCollection: sirFormFields,
      };
      break;
    case 'edge-hyperarc-en-au':
      formFieldInfo = {
        path: `edge-hyperarc-en-au-form/edge-hyperarc-en-au-form-fields`,
        key: `edgeHyperarcFormFields`,
        fieldCollection: edgeHyperarcFormFields,
      };
      break;
    case 'contact-form-no-area-of-inquiry':
      formFieldInfo = {
        path: `contact-form-no-area-of-inquiry/contact-form-no-area-of-inquiry-form-fields`,
        key: `contactNoAreaOfInquiryFormFields`,
        fieldCollection: contactNoAreaOfInquiryFormFields,
      };
      break;
  }
  return formFieldInfo;
};
